<template>
  <div>
    <vue-headful title="Maak je profiel compleet" />
    <Header page_title="Maak je profiel compleet" goBackClass="invisible" :do-not-show-all="!this.prevRoute || this.prevRoute.name !== 'applicant-edit'" />
    <div class="pt-3 px-4 mx-2 pb-4 questionnaire">
      <div class="container-fluid px-0 pb-1 mb-2">
        <form @submit.prevent="onSubmit" class="sd-form">
          <div class="step-question">
            <button type="submit" ref="submit" hidden>submit</button>
            <register-steps :steps="{1:'Gegevens',2:'Opleidingen',3:'Ervaringen',4:'Aan de slag!'}" :totalAnswered="answered" currentStep="3"></register-steps>
            <div ref="step">
              <template v-if="step === 2 && questions[2]">
                <div class="sd-title medium">
                  <span class="steps">2/{{ steps }}</span>
                  {{ questions[2].display }}
                </div>
                <div class="form pt-2">
                  <div class="pt-5 my-4" v-if="form.user_answers[questions[2].id]">
                    <VueSlideBar
                      v-model="form.user_answers[questions[2].id]['answer']"
                      :min="0"
                      :max="50"
                    >
                      <template slot="tooltip">
                        <div class="range-tooptip"></div>
                        <div class="tooptip value">
                          {{ form.user_answers[questions[2].id]["answer"] }}
                        </div>
                      </template>
                    </VueSlideBar>
                    <div class="range-values clearfix">
                      <div class="float-left">
                        <small>0</small>
                      </div>
                      <div class="float-right">
                        <small>50</small>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="step != 2 && step >= 1 && step <= 5">
                <div class="sd-title medium">
                  <span class="steps">{{ step }}/{{ steps }}</span>
                  {{ questions[step].display }}
                </div>
                <div class="form">
                  <div v-if="step == 5" class="list-unstyled">
                    <div class="form-group">
                      <textarea class="form-control" maxlength="200" placeholder="denk aan: knutselen, sportief, muzikaal, etc. Max 200 karakters" v-model="form.user_answers[questions[step].id]['answer']"  rows="5"></textarea>

                      <span class="extra-info text-left mt-2">
                        <svg-icon icon="information" />
                        Denk aan: regulier lesprogramma, creatief of muzikaal, thema’s, een specifiek vak, anders, nl. Max 200 karakters
                      </span>
                    </div>
                  </div>
                  <div v-else-if="step == 1" class="form-group">
                    <ul class="list-unstyled">
                      <li v-for="item in answers[step]" v-bind:key="item.id">
                        <div class="custom-control custom-radio">
                          <input
                            type="radio"
                            class="custom-control-input"
                            v-model="form.user_answers[questions[step].id]['answer_id']['specialism']"
                            :value="item.id"
                            v-bind:id="`experience-` + item.id"
                            name="specialism"
                          />
                          <label
                            class="custom-control-label"
                            v-bind:for="`experience-` + item.id"
                          >
                            {{ item.answer }}
                          </label>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div v-else class="form-group">
                    <ul class="list-unstyled">
                      <li v-for="item in answers[step]" v-bind:key="item.id">
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            v-model="form.user_answers[questions[step].id]['answer_id'][item.id]"
                            :value="item.id"
                            v-bind:id="`experience-` + item.id"
                          />
                          <label
                            class="custom-control-label"
                            v-bind:for="`experience-` + item.id"
                          >
                            {{ item.answer }}
                          </label>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div hidden>
            <v-stepper ref="stepper" :steps="steps" v-model="step"></v-stepper>
          </div>
        </form>
      </div>
    </div>
    <div class="step next-btn">
      <div class="px-4 mx-2">
        <button
          v-if="step < steps"
          type="button"
          title="Volgende"
          class="btn btn-warning btn-block"
          @click="nextStep"
        >
          Volgende
        </button>
        <!-- @click="$refs.stepper.next()" -->
        <!-- if action is save Opslaan
        if action is next Volgende-->
        <button
          v-if="step == steps"
          type="button"
          title="Volgende"
          class="btn btn-warning btn-block"
          @click="triggerSubmit"
        >
          {{ action == "next" ? "Volgende" : "Opslaan" }}
        </button>
      </div>
    </div>
    <div v-if="done" class="fullscreen-notif position-fixed">
      <div class="d-flex min-height align-items-center">
        <div class="container-fluid px-4 mx-2">
          <div class="text-center pb-1">
            <div class="icon svg mb-4 pb-1">
              <svg-icon icon="success" />
            </div>
            <div class="sd-title large text-uppercase bold text-white text-center mb-4">
              Dank voor het invullen!
            </div>
            <div class="">
              We hebben nu een goed beeld van jouw ervaring.
            </div>
          </div>
        </div>

        <div class="footer-btn">
          <div class="container-fluid px-4 mx-2">
            <router-link
              :to="{
                name: 'applicant-dashboard'
              }"
              title="Naar mijn dashboard"
              class="btn btn-light btn-block"
              v-ripple="'rgba(192, 189, 187, 0.35)'"
            >
              Naar mijn dashboard
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VStepper } from "vue-stepper-component";
import VueSlideBar from "vue-slide-bar";

export default {
  components: {
    VStepper,
    VueSlideBar
  },
  data: function() {
    return {
      raw: "",
      years_experience: 0,
      steps: 5,
      step: null,
      answered: 0,
      done: null,
      user: "",
      education: null,
      questions: {},
      questions_array: {},
      answers_array: {},
      answers: {},
      form: {
        user_answers: {}
      },
      prevRoute: null
    };
  },
  props: ["action"],
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData",
    step: {
      immediate: true,
      handler() {
        this.answered = Math.floor((this.step / this.steps) * 100);
      }
    },
    form: {
      handler: function() {
        localStorage.setItem("form-pending", JSON.stringify(true));
      },
      deep: true
    }
  },
  methods: {
    async fetchData() {
      await this.getQuestions();
      await this.getAnswers();
      await this.fillForm();
      await this.getUserAnswers();
      this.user = JSON.parse(localStorage.getItem("user"));
      if (this.user.education) {
        this.education = JSON.parse(this.user.education);
      }
      if (this.user.workfield != null) {
        this.step = 2;
      } else {
        this.step = 1;
      }
      localStorage.removeItem("form-pending");
    },
    // get questions
    async getQuestions() {
      let promises = [];
      var q_url = this.$apiURI + "/question/experience/2/";
      var q_ctr = 1;

      //assign questions
      while (q_ctr <= this.steps) {
        promises.push(
          new Promise(resolve => {
            this.$http({
              method: "GET",
              url: q_url + q_ctr
            }).then(
              result => {
                var q_id = result.data.data[0].id;
                var q_number = result.data.data[0].number;
                this.$set(this.questions, q_number, {
                  id: result.data.data[0].id,
                  display: result.data.data[0].display
                });
                this.$set(this.questions_array, q_number, q_id);
                resolve();
              },
              error => {
                console.error(error);
              }
            );
            q_ctr++;
          })
        );
      }
      return Promise.all(promises);
    },
    //assign answers
    async getAnswers() {
      let promises = [];
      var a_url = this.$apiURI + "/answers/2/";
      var arr = {
        qualification: 1,
        position: 3,
        age_category: 4
      };

      Object.keys(arr).forEach(itemKey => {
        promises.push(
          new Promise(resolve => {
            this.$http({
              method: "GET",
              url: a_url + itemKey
            }).then(
              result => {
                this.$set(
                  this.answers,
                  arr[itemKey], //qnumber
                  result.data.data
                );

                var answerIds = {};
                for (var v in result.data.data) {
                  answerIds[result.data.data[v].id] = false;
                }
                this.$set(this.answers_array, arr[itemKey], answerIds);
                resolve();
              },
              error => {
                console.error(error);
              }
            );
          })
        );
      });
      return Promise.all(promises);
    },
    async fillForm() {
      return new Promise(resolve => {
        Object.keys(this.questions_array).forEach(questionNumber => {
          var question_id = this.questions_array[questionNumber];
          if (questionNumber == 2) {
            this.$set(this.form.user_answers, question_id, {
              answer: 0
            });
          } else if (questionNumber == 5) {
            this.$set(this.form.user_answers, question_id, {
              answer: ""
            });
          } else if (questionNumber == 1) {
            this.$set(this.form.user_answers, question_id, {
              answer_id: {
                'specialism': this.answers_array[questionNumber]
              }
            });
          } else {
            this.$set(this.form.user_answers, question_id, {
              answer_id: this.answers_array[questionNumber]
            });
          }
        });
        resolve();
      });
    },
    async getUserAnswers() {
      return new Promise((resolve, reject) => {
        var url = "applicant/answers/raw/2/experience";
        let user_token = JSON.parse(localStorage.getItem("user-token"));
        this.$http
          .get(this.$apiURI + "/" + url, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(resp => {
            if (resp.data.data) {
              this.raw = resp.data.data;
              for (var obj in this.raw) {
                if (this.raw[obj].question_id === 33 || this.raw[obj].question_id === 36) {
                  this.form.user_answers[this.raw[obj].question_id][
                    "answer"
                  ] = this.raw[obj].answer;
                } else if (this.raw[obj].question_id === 32) {
                  this.form.user_answers[this.raw[obj].question_id]["answer_id"]["specialism"] = this.raw[obj].answer_id;
                } else {
                  this.form.user_answers[this.raw[obj].question_id][
                    "answer_id"
                  ][this.raw[obj].answer_id] = true;
                }
              }
            }
            return resolve();
          })
          .catch(() => {
            // console.log(error);
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden."
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            return reject(null);
          });
      });
    },
    triggerSubmit() {
      var elem = this.$refs.submit;
      elem.click();
    },
    async onSubmit() {
      var next = this.validateForm();
      if (next) {
        // continue
        await this.saveExperience();
        await this.updateLocalUser();
        // if (this.action == "next") {
        //   setTimeout(
        //     () =>
        //       this.$router.replace({
        //         name: "applicant-step_3",
        //         params: { action: "save" }
        //       }),
        //     10000
        //   );
        // }
        if (this.action == "save" && Object.keys(this.education).length >= 5) {
          // go to user profile
          // setTimeout(
          //   () =>
          //     this.$router.replace({
          //       name: "applicant-profile"
          //     }),
          //   10000
          // );
        }
      }
    },
    async saveExperience() {
      return new Promise(resolve => {
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/user_answer/experience/2";
        let formData = {
          user_answer: this.form["user_answers"]
        };
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            // console.log(success);
            this.done = true;
            console.log(this.done);
            localStorage.removeItem("form-pending");
            resolve();
          })
          .catch(() => {
            // console.log(error.response.data);
            this.done = true;
            console.log(this.done);
            localStorage.removeItem("form-pending");
            resolve();
          });
      });
    },
    nextStep() {
      var next = this.validateForm();
      window.scrollTo(0, 0);
      if (next) {
        this.$refs.stepper.next();
      }
    },
    validateForm() {
      if (this.step === 5) {
        if (this.form.user_answers[this.questions[5].id]['answer'] === '') {
          alert("Vul de daginvulling in om door te gaan.");
          return false;
        } else
          return true;
      } else if (this.step === 1) {
        var $radiobuttons = $('input[type="radio"]:visible');
        if ($radiobuttons.length) {
          var checkedRadios = $('input[type="radio"]:visible:checked').length;
          if (!checkedRadios) {
            alert("Selecteer één antwoord om door te gaan.");
            return false;
          }
        }
      } else {
        var $checkboxes = $('input[type="checkbox"]:visible');
        if ($checkboxes.length) {
          var checkedCheckboxes = $('input[type="checkbox"]:visible:checked').length;
          if (!checkedCheckboxes) {
            alert("Selecteer één of meerdere antwoorden om door te gaan.");
            return false;
          }
        } else {
          return true;
        }
      }
      return true;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  beforeRouteLeave(to, from, next) {
    this.savePending(to, from, next);
  }
};
</script>

<style scoped>
.card {
  border-radius: 5px;
  overflow: hidden;
}
.card-body {
  min-height: 135px;
}

.range-values div {
  position: relative;
  margin-top: -2px;
}
.range-values .float-left {
  left: -3px;
}
.range-values .float-right {
  right: -8px;
}

.fullscreen-notif .icon.svg svg {
  right: -22px;
}

.step-question .notification-container {
  margin-top: 25px;
}
.questionnaire {
  padding-bottom:4rem!important;
}
</style>
